import classNames from "classnames";
import Icon from "../icon";
import InputField from "./input-field";

type InputPhoneProps = {
  defaultValue?: string;
  required?: boolean;
  readOnly?: boolean;
  containerClassName?: string;
};

const COUNTRY_CODES = [
  "+1",
  "+7",
  "+20",
  "+27",
  "+30",
  "+31",
  "+32",
  "+33",
  "+34",
  "+36",
  "+39",
  "+41",
  "+43",
  "+44",
  "+45",
  "+46",
  "+47",
  "+48",
  "+49",
  "+50",
  "+51",
  "+52",
  "+53",
  "+54",
  "+55",
  "+56",
  "+57",
  "+58",
  "+60",
  "+61",
  "+62",
  "+63",
  "+64",
  "+65",
  "+66",
  "+68",
  "+69",
  "+81",
  "+82",
  "+84",
  "+86",
  "+88",
  "+90",
  "+91",
  "+92",
  "+93",
  "+94",
  "+95",
  "+98",
  "+212",
  "+213",
  "+216",
  "+218",
  "+220",
  "+221",
  "+222",
  "+223",
  "+224",
  "+225",
  "+226",
  "+227",
  "+228",
  "+229",
  "+230",
  "+231",
  "+232",
  "+233",
  "+234",
  "+235",
  "+236",
  "+237",
  "+238",
  "+239",
  "+240",
  "+241",
  "+242",
  "+243",
  "+244",
  "+245",
  "+246",
  "+247",
  "+248",
  "+249",
  "+250",
  "+251",
  "+252",
  "+253",
  "+254",
  "+255",
  "+256",
  "+257",
  "+258",
  "+260",
  "+261",
  "+262",
  "+263",
  "+264",
  "+265",
  "+266",
  "+267",
  "+268",
  "+269",
  "+282",
  "+283",
  "+284",
  "+285",
  "+286",
  "+287",
  "+288",
  "+289",
  "+290",
  "+291",
  "+292",
  "+293",
  "+294",
  "+295",
  "+296",
  "+297",
  "+298",
  "+299",
  "+351",
  "+353",
  "+354",
  "+355",
  "+356",
  "+357",
  "+358",
  "+359",
  "+370",
  "+371",
  "+372",
  "+373",
  "+374",
  "+375",
  "+376",
  "+377",
  "+378",
  "+380",
  "+381",
  "+382",
  "+385",
  "+386",
  "+387",
  "+389",
  "+420",
  "+421",
  "+423",
  "+852",
  "+853",
  "+886",
  "+971",
  "+972",
  "+973",
  "+974",
  "+975",
  "+976",
  "+977",
  "+992",
  "+993",
  "+994",
  "+995",
  "+996",
  "+998",
];

const InputPhone = (props: InputPhoneProps) => {
  const countryCode =
    COUNTRY_CODES.find((code) => props.defaultValue?.startsWith(code)) || "+46";

  const phone = props.defaultValue?.replace(countryCode, "");

  return (
    <div
      className={classNames(
        "flex items-start space-x-2",
        props.containerClassName
      )}
    >
      <div className="relative">
        <select
          name="countryCode"
          defaultValue={countryCode}
          disabled={props.readOnly}
          required={props.required}
          className="appearance-none text-[16px] bg-sand-200 rounded-sm text-gray-t00 px-4 pr-10 h-16 border border-sand-600 placeholder:text-gray-400 disabled:bg-sand-600 disabled:text-gray-200 disabled:cursor-not-allowed"
        >
          {COUNTRY_CODES.map((code) => (
            <option key={code} value={code} selected={code === countryCode}>
              {code}
            </option>
          ))}
        </select>

        <Icon.ChevronDown className="!size-5 absolute inset-y-0 my-auto right-4 pointer-events-none" />
      </div>

      <InputField
        label="Mobilnummer"
        name="phone"
        type="tel"
        placeholder="Ange mobilnummer"
        containerClassName="flex-1"
        readOnly={props.readOnly}
        required={props.required}
        defaultValue={phone}
        helpText="Ange nummer utan landskod"
        pattern="^[0-9]{9,14}$"
        autoComplete="tel-national"
      />
    </div>
  );
};

export default InputPhone;
